document.addEventListener('DOMContentLoaded', () => {
  const categorySearchForm = document.getElementById('category-search-form');
  const categorySearch = document.getElementById('category-search');

  if (categorySearchForm) {
    categorySearch.addEventListener('change', e => {
      categorySearchForm.action = `${site_url}/category/${e.currentTarget.value}`;
    });
  }
});
